import { createRouterReactBindings } from '@w/react-router'
import type { FlashcardsFeRouter } from './flashcards-fe.router'

export const {
  RouterProvider,
  useNavigate,
  useRouter,
  useParams,
  useSearch,
  useLoaderData,
  useQueue,
  useLocationState,
  useRouterContext,
  Link,
  Outlet,
} = createRouterReactBindings<FlashcardsFeRouter>()
